// extracted by mini-css-extract-plugin
export default {"Alien":"alien_Alien__m11Ry"};